import PropTypes from "prop-types";
import React, { Component } from "react";
import { Field } from "formik";
import * as _ from "lodash";
import { connect } from "react-redux";
import { checkboxComponent, radiosComponent } from "../../forms/customInput";
import {
  customInputComponent,
  customInputSelectComponent,
  CustomInputDateComponent,
} from "../../forms/customInputBronson";
import { Card } from "../Card/card";
import i18n from "../../i18n";
import * as rk from "../../localization/resourceKeys";
import { withTranslation, Trans } from "react-i18next";
import {
  ccpaFormValidations,
  mailingAddressValidations,
} from "../../utils/validations";
import { SkipNavLink, SkipNavContent } from "@reach/skip-nav";
import BannerNotification from "../../banner/bannerNotification";
import {
  statesInfo,
  texasLikeStates,
  utahLikeStates,
  virginiaLikeStates,
} from "../../utils/statesUS";
import { provinces, provincesInFrench } from "../../utils/canadaMatrix";
import "@reach/skip-nav/styles.css";
import "./mailingAddress.css";

class MailingAddress extends Component {
  constructor(props) {
    super(props);

    this.state = {
      actualSsn: props.initialValues.ssn,
      maskedSsn: "*".repeat(props.initialValues.ssn.length),
      showFullSSN: false,
    };

    this.handleMaskedFieldChange = this.handleMaskedFieldChange.bind(this);
    this.handleHeaderText = this.handleHeaderText.bind(this);
    this.showFullSSN = this.showFullSSN.bind(this);
  }

  handleHeaderText = (state, t, isDNS, showVWGoAText) => {
    const { country } = this.props;
    const CANADA = country.toLowerCase() === "canada";
    if (CANADA) {
      return (
        <>
          <div>{t(rk.INFO_FORM.QUESTION_CANADA_QC_1)}</div>
          <div className="u-mt-small">
            {t(rk.INFO_FORM.QUESTION_CANADA_QC_2)}
          </div>
        </>
      );
    }

    if (showVWGoAText) {
      return (
        <Trans i18nKey={rk.INFO_FORM.QUESTION_DNS_BEHALF}>
          We will need some information about the consumer to locate their
          information in our records to process this request. Please ensure this
          information is accurate and up to date. Providing optional information
          (such as phone number and/or physical address) may better enable us to
          successfully locate the consumer in our systems to fulfill your
          request. The consumer should also visit the cookie preference center
          on the websites the consumer interacts with to opt out of cookie-based
          selling/sharing/targeted advertising. Clicking the “Do Not Sell or
          Share My Personal Information for Targeted Advertising” link in the
          website footer and turning the “Sale/Sharing/Targeted Advertising”
          option off will opt the consumer out of selling, sharing, and targeted
          advertising that is conducted through cookies and other tracking
          technologies.
        </Trans>
      );
    }

    if (isDNS) {
      return t(rk.INFO_FORM.QUESTION_DNS);
    }
    const stateQuestions = {
      CA: rk.INFO_FORM.QUESTION_CA,
      VA: rk.INFO_FORM.QUESTION_VA,
    };

    return t(stateQuestions[state] || rk.INFO_FORM.QUESTION);
  };

  requiredFields = () => {
    const isVWGoA =
      this.props?.stateSelector?.brandAffiliation ===
        i18n.t(rk.BRANDS_OPTION_VWFS_DFS_AFS) ||
      this.props?.stateSelector?.brandAffiliation ===
        i18n.t(rk.BRANDS_OPTION_VW_AUDI);
    const isDNSRequest =
      this.props.selectedRequest ===
      i18n.t(rk.REQUEST_SELECTOR.DO_NOT_SELL_INFO);
    const isBehalfSelf =
      this.props?.stateSelector?.submissionOnBehalfOf ===
      i18n.t(rk.ON_BEHALF_OPTION_SELF);
    const isBehalfAgent =
      this.props?.stateSelector?.submissionOnBehalfOf ===
      i18n.t(rk.ON_BEHALF_OPTION_OTHER_CA);

    return isDNSRequest && isVWGoA && (isBehalfSelf || isBehalfAgent);
  };

  categoriesReport = (t, isPSandCA, isRepresentativeOfBussines) => {
    if (isPSandCA)
      return (
        <div>
          <div>
            {t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY_PS_CA_0)}
            <b className="bold-text">
              {t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY_PS_CA_1)}
            </b>
            {isRepresentativeOfBussines
              ? t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY_PS_CA_REP_OF_B_2)
              : t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY_PS_CA_2)}
          </div>
          <br />
          <div>{t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY_PS_CA_3)}</div>
          <br />
          <div>
            {isRepresentativeOfBussines
              ? t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY_PS_CA_REP_OF_B_4)
              : t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY_PS_CA_4)}
          </div>
        </div>
      );
    else
      return (
        <div>
          <div>
            {t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY4)}
            <b className="bold-text">
              {t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY0)}
            </b>
            {t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY1)}
          </div>
          <br />
          {this.props.country.toLowerCase() !== "canada" && (
            <div>
              <div>{t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY5)}</div>
              <br />
            </div>
          )}
          <div>{t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY2)}</div>
        </div>
      );
  };

  specificPiecesReport = (
    t,
    isPSandTexasLike,
    isPSandCA,
    isRepresentativeOfBussines,
    isProtectionServices,
    isQC
  ) => {
    const currentStateResidence = this.props.currentStateResidence;
    const isCAorTX = [
      i18n.t(rk.STATE_CALIFORNIA),
      i18n.t(rk.STATE_TX),
    ].includes(currentStateResidence);
    const showCAandTXContent = !isProtectionServices && isCAorTX;
    if (isPSandTexasLike)
      return (
        <div>
          <div>
            {t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY_PS_TX_0)}
            <b className="bold-text">
              {t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY_PS_TX_1)}
            </b>
            {t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY_PS_TX_2)}
          </div>
          <br />
          <div>{t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY_PS_TX_3)}</div>
          <br />
          <div>{t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY_PS_TX_4)}</div>
          <br />
          <div>{t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY_PS_TX_5)}</div>
        </div>
      );
    else if (isPSandCA)
      return (
        <div>
          <div>
            {t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES_CARD_BODY_PS_CA_0)}
            <b className="bold-text">
              {t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES_CARD_BODY_PS_CA_1)}
            </b>
            {t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES_CARD_BODY_PS_CA_2)}
          </div>
          <br />
          <div>{t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES_CARD_BODY_PS_CA_3)}</div>
          <br />
          {!isRepresentativeOfBussines && (
            <>
              <div>
                {t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES_CARD_BODY_PS_CA_4)}
              </div>
              <br />
            </>
          )}
          <div>{t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES_CARD_BODY_PS_CA_5)}</div>
        </div>
      );
    else if (isQC)
      return (
        <div>
          <div>
            {t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES_CARD_BODY_CANADA_QC_1)}
            <b className="bold-text">
              {t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES_CARD_BODY0)}
            </b>
            {t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES_CARD_BODY_CANADA_QC_2)}
          </div>
          <br />
          <div>
            {t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES_CARD_BODY_CANADA_QC_3)}
          </div>
        </div>
      );
    else
      return (
        <div>
          <div>
            {t(rk.INFO_FORM.REPORT_CATEGORY_CARD_BODY4)}
            <b className="bold-text">
              {t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES_CARD_BODY0)}
            </b>
            {showCAandTXContent
              ? t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES_CARD_BODY_NON_PS_1)
              : t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES_CARD_BODY1)}
          </div>
          <br />
          <div>{t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES_CARD_BODY2)}</div>
        </div>
      );
  };

  showFullSSN = () => {
    const specificPieces =
      this.props.values.reportType ===
      i18n.t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES);
    const correctInfoAndRepresentativeCA =
      this.props.isCorrectMyInfo &&
      this.props.customerRelation === i18n.t(rk.QUESTION_2_OPTION_3) &&
      this.props.currentStateResidence === i18n.t(rk.STATE_CALIFORNIA);
    if (
      correctInfoAndRepresentativeCA ||
      specificPieces ||
      this.props.isProtectionServices
    ) {
      this.setState({ ...this.state, showFullSSN: true });
    } else {
      this.setState({ ...this.state, showFullSSN: false });
    }
  };

  componentDidMount() {
    this.showFullSSN();

    window.scrollTo(0, 0);
    ccpaFormValidations(this.props.country);
    mailingAddressValidations(this.props.country);
  }

  maskValue(valueToMask) {
    const value = ("" + valueToMask).replace(/\D/g, "");
    const regex = /^(\d{3})(\d{3})(\d{4})$/;
    const updatedValue = regex.exec(value);
    if (updatedValue) {
      return (
        "(" + updatedValue[1] + ") " + updatedValue[2] + "-" + updatedValue[3]
      );
    }
    return value;
  }

  handleMaskedFieldChange(event, setFieldValue) {
    const actualSsn = this.state.actualSsn;
    const value = event.target.value;
    const length = value.length;

    let newValue;
    if (actualSsn.length < length - 1 || actualSsn.length === length) {
      newValue = value.replace(/\D/g, "");
    } else {
      newValue =
        actualSsn.slice(0, length) + value.replace(/\D/g, "").slice(-1);
    }

    setFieldValue("ssn", newValue);
    this.setState({
      actualSsn: newValue,
      maskedSsn: "*".repeat(newValue.length),
    });
  }

  onReportCheck = (e, setFieldValue) => {
    setFieldValue("reportCheck", !this.props.values.reportCheck);
    e.preventDefault();
  };

  goBackHome = () => {
    this.props.history.push("/canada");
  };

  formatZip = (event, setFieldValue) => {
    const value = event.target.value;

    if (this.props?.country?.toUpperCase() === "CANADA") {
      if (value.length > 3) {
        const formatted = value.split(" ").join("");
        const newZip = `${formatted.slice("0", "3")} ${formatted.slice("3")}`;
        setFieldValue("postalCode", newZip);
      } else {
        setFieldValue("postalCode", value);
      }
      return;
    }
    setFieldValue("postalCode", value);
  };

  render() {
    const {
      setFieldValue,
      t,
      handleFieldBlur,
      handleSubmit,
      networkError,
      isAccessMyInfo,
      isKnowMyInfo,
      isDNS,
      isCorrectMyInfo,
      isDeleteMyInfoVALikeOrUTLike,
      isDeleteMyInfoSpecialPolicyState,
      isDeleteMyInfoQC,
      isProtectionServices,
      values,
      stateSelector,
    } = this.props;
    const reportTypeLabel = t(values.reportTypeLabel);
    const currentStateResidence =
      this.props.stateSelector.currentStateResidence;
    const isBentley =
      this.props?.stateSelector?.brandAffiliation ===
      i18n.t(rk.BENTLEY_CUSTOMER_OPTION_BENTLEY);
    const isVWGoA =
      this.props?.stateSelector?.brandAffiliation ===
        i18n.t(rk.BRANDS_OPTION_VWFS_DFS_AFS) ||
      this.props?.stateSelector?.brandAffiliation ===
        i18n.t(rk.BRANDS_OPTION_VW_AUDI);
    const isBehalfOfConsumer =
      this.props?.stateSelector?.submissionOnBehalfOf ===
      i18n.t(rk.ON_BEHALF_OPTION_OTHER_CA);
    const showVWGoAText = isVWGoA && isBehalfOfConsumer && isDNS;

    const isQC = currentStateResidence === i18n.t(rk.STATE_QUEBEC);
    const applicableStates = virginiaLikeStates.concat(utahLikeStates);
    const isApplicableState = applicableStates.includes(
      i18n.t(currentStateResidence)
    );
    const requiredFields = this.requiredFields();

    const isPSandTexasLike =
      isProtectionServices && texasLikeStates.includes(currentStateResidence);
    const isPSandCA =
      isProtectionServices &&
      currentStateResidence === i18n.t(rk.STATE_CALIFORNIA);
    const isVALikeOrUTLike = virginiaLikeStates.includes(currentStateResidence);
    const showSSN =
      !(isDNS || isDeleteMyInfoVALikeOrUTLike) &&
      !isQC &&
      !(isDeleteMyInfoSpecialPolicyState && isProtectionServices);
    const isFrench = this.props.language.toUpperCase() === "FRA";
    const ssnLabel =
      values.reportType === t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES) ||
      isCorrectMyInfo ||
      isProtectionServices
        ? t(rk.COMMON.FULL_SSN)
        : t(rk.COMMON.LAST4_SSN);
    const isCosumerNotFoundError =
      networkError?.error?.data?.experianResponseCodes?.errorQkbMessage ===
        t(rk.EXPERIAN_FORM.API_CONSUMER_NOT_FOUND_RESPONSE) || false;
    const isKnowMyInfoCA =
      currentStateResidence === i18n.t(rk.STATE_CALIFORNIA) && isKnowMyInfo;

    // This variable determines if the VIN field should be shown in the form.
    // It will be true only if ALL of the following are false:
    // - isKnowMyInfoCA: User is not in California with a "Know My Info" request
    // - isDeleteMyInfoSpecialPolicyState: Not in a special policy state for "Delete My Info"
    // - isProtectionServices: Not a protection services request
    // - isDeleteMyInfoQC: Not a "Delete My Info" request for Quebec
    // - isAccessMyInfo: Not an "Access My Info" request
    // - isVALikeOrUTLike: Not in a Virginia/Utah-like state
    // - isApplicableState: Not in the list of applicable states
    // - isQC: Not in Quebec
    // If any of these are true, the VIN field will NOT be shown.
    const shouldShowVinField = !(
      isKnowMyInfoCA ||
      isDeleteMyInfoSpecialPolicyState ||
      isProtectionServices ||
      isDeleteMyInfoQC ||
      isAccessMyInfo ||
      isVALikeOrUTLike ||
      isApplicableState ||
      isQC
    );

    const isRepresentativeOfBussines =
      this.props.customerRelation === i18n.t(rk.QUESTION_2_OPTION_3);
    if (document.getElementById("ssn")) {
      if (
        isCorrectMyInfo ||
        isProtectionServices ||
        values.reportType === t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES)
      ) {
        document.getElementById("ssn").setAttribute("maxlength", 9);
      } else {
        document.getElementById("ssn").setAttribute("maxlength", 4);
      }
    }
    const frenchProvinces =
      this.props.language.toUpperCase() === "FRA"
        ? provincesInFrench
        : provinces;
    const regionOptions =
      this.props.country === "Canada" ? frenchProvinces : statesInfo;
    const showNote = (isBentley && isDNS) || (!isAccessMyInfo && !isQC && !showVWGoAText && !isDNS);
    const showNoteDNS = isDNS && !isAccessMyInfo && !isQC && !showVWGoAText && !isBentley;

    const showNote2 = isCorrectMyInfo && !isProtectionServices && !isDNS;
    return (
      <React.Fragment>
        <SkipNavLink />
        {!_.isEmpty(networkError) && (
          <BannerNotification notificationStyle="error">
            {isCosumerNotFoundError
              ? t(rk.EXPERIAN_FORM.API_VERIFY_ERROR)
              : t(rk.ERROR_API_FAIL)}
          </BannerNotification>
        )}
        <div
          className="mailing-addr-questionnaire"
          data-testid="mailing-addr-questionnaire-div"
          onSubmit={handleSubmit}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSubmit();
            }
          }}
        >
          <div
            data-testid="ccpa-questionnaire"
            className="ccpa-questionnaire"
            onSubmit={handleSubmit}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit();
              }
            }}
          >
            {!isDeleteMyInfoQC && (
              <div className="o-layout u-m-none">
                <div className="o-layout__item u-1/1 u-m-none header-text-fs personal-info u-p-none@s u-p-none@xs">
                  {this.handleHeaderText(
                    currentStateResidence,
                    t,
                    isDNS,
                    showVWGoAText,
                    stateSelector
                  )}
                  <br />
                </div>

                <div
                  className={`personal-info ${
                    isDeleteMyInfoSpecialPolicyState ? "u-mb" : ""
                  }`}
                >
                  {showNoteDNS && (
                    <div className="o-layout__item u-1/1 u-mt-xsmall header-text-fs u-p-none@s u-p-none@xs">
                      {t(rk.INFO_FORM.NOTE_DNS_1)} <br />
                      <br /> {t(rk.INFO_FORM.NOTE_DNS_2)}
                    </div>
                  )}
                  {showNote && (
                    <div className="o-layout__item u-1/1 u-mt-xsmall header-text-fs u-p-none@s u-p-none@xs">
                      {t(rk.INFO_FORM.NOTE)}
                    </div>
                  )}

                  {showNote2 && (
                    <div className="o-layout__item u-1/1 u-mt-xsmall header-text-fs u-p-none@s u-p-none@xs">
                      {i18n.t(rk.INFO_FORM.NOTE_2)}
                    </div>
                  )}
                </div>
              </div>
            )}

            {isDeleteMyInfoQC && (
              <>
                <div className="heading">{i18n.t(rk.DELETE_FORM.HEADER)}</div>
                <div className="o-layout__item u-mb">
                  <div className="center-div u-mb-small">
                    <button
                      id="go-homescreen-btn"
                      className="c-btn u-mv-none"
                      data-testid="qcpp-go-homescreen-button"
                      onClick={() => this.goBackHome()}
                    >
                      <span className="c-btn__text">
                        {i18n.t(rk.DELETE_FORM.HOMESCREEN_BUTTON)}
                      </span>
                    </button>
                  </div>
                </div>
              </>
            )}

            {isAccessMyInfo && (
              <div className="o-layout u-m-none">
                <div className="o-layout__item u-mb">
                  <div className="center-div u-mb-small">
                    <a
                      className="request-form-link"
                      href={"?downloadRequestForm"}
                      download="AccessMyInfoForm"
                    >
                      <button
                        id="download-request-btn"
                        className="c-btn u-mv-none"
                        data-testid="qcpp-download-request-button"
                      >
                        <span className="c-btn__text">
                          {i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_OR_REP_CTA)}
                        </span>
                      </button>
                    </a>
                  </div>
                </div>
                <div className="o-layout__item u-mt u-mb-large">
                  <p className="u-font-size-fs0">
                    {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_TEXT_1)}
                  </p>
                  <span>
                    <p className="u-mb-none intructions-title u-font-size-fs0">
                      {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_TEXT_2)}
                    </p>
                    <p className="u-mb-none u-font-size-fs0">
                      {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_TEXT_3)}
                    </p>
                    <p className="u-mb-none u-font-size-fs0">
                      {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_TEXT_4)}
                    </p>
                  </span>
                </div>
              </div>
            )}

            {!isDeleteMyInfoQC && !isAccessMyInfo && (
              <>
                {this.props.showReportOptions && (
                  <div className="o-layout u-m-none u-mb">
                    {!isPSandTexasLike && (
                      <div className="o-layout__item u-1/3 u-m-none radio-fs category-report-type">
                        <Field
                          id="category-report"
                          data-testid="category-report"
                          radioText={t(rk.INFO_FORM.REPORT_CATEGORY)}
                          onClick={() => {
                            setFieldValue(
                              "reportType",
                              t(rk.INFO_FORM.REPORT_CATEGORY)
                            );
                            setFieldValue(
                              "reportTypeLabel",
                              rk.INFO_FORM.REPORT_CATEGORY
                            );
                            if (document.getElementById("ssn")) {
                              document
                                .getElementById("ssn")
                                .setAttribute("maxlength", 4);
                            }
                          }}
                          isChecked={
                            reportTypeLabel === t(rk.INFO_FORM.REPORT_CATEGORY)
                          }
                          component={radiosComponent}
                          customName={"tier-1-report"}
                        />
                      </div>
                    )}
                    <div className="o-layout__item u-1/3 u-m-none radio-fs category-report-type">
                      <Field
                        id="specific-pieces-report"
                        data-testid="specific-pieces-report"
                        radioText={t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES)}
                        onClick={() => {
                          setFieldValue(
                            "reportType",
                            t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES)
                          );
                          setFieldValue(
                            "reportTypeLabel",
                            rk.INFO_FORM.REPORT_SPECIFIC_PIECES
                          );
                          if (document.getElementById("ssn")) {
                            document
                              .getElementById("ssn")
                              .setAttribute("maxlength", 9);
                          }
                        }}
                        isChecked={
                          reportTypeLabel ===
                          t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES)
                        }
                        component={radiosComponent}
                        customName={"tier-2-report"}
                      />
                    </div>
                  </div>
                )}
                {this.props.showReportOptions &&
                  reportTypeLabel === t(rk.INFO_FORM.REPORT_CATEGORY) && (
                    <div className="o-layout u-m-none u-pl report-card u-pl-none@xs u-pl-none@s">
                      <div className="u-1/1">
                        <Card
                          content={this.categoriesReport(
                            t,
                            isPSandCA,
                            isRepresentativeOfBussines
                          )}
                        />
                      </div>
                    </div>
                  )}
                {this.props.showReportOptions &&
                  reportTypeLabel ===
                    t(rk.INFO_FORM.REPORT_SPECIFIC_PIECES) && (
                    <div className="o-layout u-m-none u-pl report-card u-pl-none@xs u-pl-none@s">
                      <div className="u-1/1">
                        <Card
                          content={this.specificPiecesReport(
                            t,
                            isPSandTexasLike,
                            isPSandCA,
                            isRepresentativeOfBussines,
                            isProtectionServices,
                            isQC
                          )}
                        />
                      </div>
                    </div>
                  )}
                {requiredFields && (
                  <div className="o-layout__item required-text">
                    {t(rk.COMMON.REQUIRED_TEXT)}
                  </div>
                )}

                <div className="o-layout u-m-none">
                  <div className="o-layout__item u-1/3 u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none">
                    <SkipNavContent />
                    <Field
                      name="firstName"
                      data-testid="firstName"
                      placeHolder={
                        requiredFields
                          ? t(rk.COMMON.REQUIRED_FIELD) +
                            t(rk.COMMON.FIRST_NAME)
                          : t(rk.COMMON.FIRST_NAME)
                      }
                      altPlaceholder={t(rk.COMMON.FIRST_NAME).toUpperCase()}
                      type="text"
                      id="firstName"
                      component={customInputComponent}
                      disabled={this.props.secureKey?.givenName}
                      error={this.props.errors.firstName}
                      helpContent={
                        this.props.errors.firstName &&
                        this.props.touched.firstName
                          ? this.props.errors.firstName
                          : ""
                      }
                    />
                  </div>
                  <div
                    className={`o-layout__item u-1/3 u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none ${
                      isFrench && "french-form-label"
                    }`}
                  >
                    <Field
                      name="middleInitial"
                      data-testid="middleInitial"
                      placeHolder={
                        requiredFields
                          ? t(rk.COMMON.MIDDLE_NAME)
                          : t(rk.COMMON.MIDDLE_NAME) +
                            ` (${t(rk.COMMON.OPTIONAL)})`
                      }
                      altPlaceholder={t(rk.COMMON.MIDDLE_NAME).toUpperCase()}
                      type="text"
                      id="middleInitial"
                      component={customInputComponent}
                      disabled={this.props.secureKey?.middleName}
                      error={this.props.errors.middleInitial}
                      helpContent={
                        this.props.errors.middleInitial &&
                        this.props.touched.middleInitial
                          ? this.props.errors.middleInitial
                          : ""
                      }
                    />
                  </div>
                  <div
                    className={`o-layout__item u-1/3 u-1/@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none ${
                      isDNS || isDeleteMyInfoVALikeOrUTLike ? "u-1/1" : "u-1/2"
                    }`}
                  >
                    <Field
                      name="lastName"
                      data-testid="lastName"
                      placeHolder={
                        requiredFields
                          ? t(rk.COMMON.REQUIRED_FIELD) + t(rk.COMMON.LAST_NAME)
                          : t(rk.COMMON.LAST_NAME)
                      }
                      altPlaceholder={t(rk.COMMON.LAST_NAME).toUpperCase()}
                      type="text"
                      id="lastName"
                      component={customInputComponent}
                      disabled={this.props.secureKey?.familyName}
                      error={this.props.errors.lastName}
                      helpContent={
                        this.props.errors.lastName &&
                        this.props.touched.lastName
                          ? this.props.errors.lastName
                          : ""
                      }
                    />
                  </div>
                </div>
                <div className="o-layout u-m-none">
                  <div className="o-layout__item u-1/2 u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none">
                    <Field
                      id="emailAddress"
                      name="emailAddress"
                      data-testid="emailAddress"
                      placeHolder={
                        requiredFields
                          ? t(rk.COMMON.REQUIRED_FIELD) +
                            t(rk.COMMON.EMAIL_ADDRESS)
                          : t(rk.COMMON.EMAIL_ADDRESS)
                      }
                      altPlaceholder={t(rk.COMMON.EMAIL_ADDRESS).toUpperCase()}
                      type="email"
                      component={customInputComponent}
                      error={this.props.errors.emailAddress}
                      helpContent={
                        this.props.errors.emailAddress &&
                        this.props.touched.emailAddress
                          ? this.props.errors.emailAddress
                          : ""
                      }
                    />
                  </div>
                  <div className="o-layout__item u-1/2 u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none">
                    <Field
                      id="reEnterEmailAddress"
                      name="reEnterEmailAddress"
                      data-testid="reEnterEmailAddress"
                      placeHolder={
                        requiredFields
                          ? t(rk.COMMON.REQUIRED_FIELD) +
                            t(rk.COMMON.RENTER_EMAIL_ADDRESS)
                          : t(rk.COMMON.RENTER_EMAIL_ADDRESS)
                      }
                      altPlaceholder={t(
                        rk.COMMON.RENTER_EMAIL_ADDRESS
                      ).toUpperCase()}
                      type="email"
                      component={customInputComponent}
                      error={this.props.errors.reEnterEmailAddress}
                      helpContent={
                        this.props.errors.reEnterEmailAddress &&
                        this.props.touched.reEnterEmailAddress
                          ? this.props.errors.reEnterEmailAddress
                          : ""
                      }
                    />
                  </div>
                </div>
                <div className="o-layout u-m-none">
                  {!(
                    isDNS ||
                    isDeleteMyInfoVALikeOrUTLike ||
                    (isDeleteMyInfoSpecialPolicyState && isProtectionServices)
                  ) && (
                    <div
                      className={`o-layout__item ${
                        showSSN ? "u-1/2" : "u-1/1"
                      } u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none`}
                    >
                      <Field
                        name="dateOfBirth"
                        testid="dateOfBirth"
                        placeHolder={t(rk.COMMON.DOB)}
                        altPlaceholder={t(rk.COMMON.DOB).toUpperCase()}
                        type={"date"}
                        id="dateOfBirth"
                        className="ccpa-dob-field"
                        component={CustomInputDateComponent}
                        secureKeyProps={this.props.secureKey}
                        disabled={this.props.secureKey?.birthDate}
                        setFieldValue={setFieldValue}
                        error={this.props.errors.dateOfBirth}
                        helpContent={
                          this.props.errors.dateOfBirth &&
                          this.props.touched.dateOfBirth
                            ? this.props.errors.dateOfBirth
                            : ""
                        }
                      />
                    </div>
                  )}
                  {showSSN && (
                    <div className="o-layout__item u-1/2 u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none">
                      <Field
                        name="ssn"
                        data-testid="ssn"
                        placeHolder={ssnLabel}
                        altPlaceholder={ssnLabel.toUpperCase()}
                        type="text"
                        id="ssn"
                        onChange={(e) =>
                          this.handleMaskedFieldChange(e, setFieldValue)
                        }
                        component={customInputComponent}
                        error={this.props.errors.ssn}
                        helpContent={
                          this.props.touched.ssn &&
                          this.props.errors.ssn &&
                          this.props.errors.ssn
                        }
                        value={this.state.maskedSsn}
                      />
                    </div>
                  )}
                </div>
                <div className="o-layout__item u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none">
                  <Field
                    name="phone"
                    data-testid="phone"
                    placeHolder={t(rk.COMMON.PHONE_NUMBER)}
                    altPlaceholder={t(rk.COMMON.PHONE_NUMBER).toUpperCase()}
                    type="text"
                    id="phone"
                    maskValue={this.maskValue}
                    component={customInputComponent}
                    error={this.props.errors.phone}
                    helpContent={
                      this.props.errors.phone && this.props.touched.phone
                        ? this.props.errors.phone
                        : ""
                    }
                  />
                </div>
              </>
            )}
          </div>
          {!isDeleteMyInfoQC && (
            <>
              <div className="o-layout u-m-none">
                <div className="o-layout__item u-1/2 u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none">
                  <SkipNavContent />
                  <Field
                    name="addressLine1"
                    data-testid="addressLine1"
                    type="text"
                    placeHolder={t(rk.COMMON.ADDRESS_LINE1)}
                    altPlaceholder={t(rk.COMMON.ADDRESS_LINE1).toUpperCase()}
                    id="addressLine1"
                    component={customInputComponent}
                    error={this.props.errors.addressLine1}
                    helpContent={
                      this.props.errors.addressLine1 &&
                      this.props.touched.addressLine1
                        ? this.props.errors.addressLine1
                        : ""
                    }
                    handleBlur={(e) => {
                      handleFieldBlur(e);
                    }}
                  />
                </div>
                <div className="o-layout__item u-1/2 u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none">
                  <Field
                    name="addressLine2"
                    data-testid="addressLine2"
                    type="text"
                    placeHolder={t(rk.COMMON.ADDRESS_LINE2)}
                    altPlaceholder={t(rk.COMMON.ADDRESS_LINE2).toUpperCase()}
                    id="addressLine2"
                    component={customInputComponent}
                    error={this.props.errors.addressLine2}
                    helpContent={
                      this.props.errors.addressLine2 &&
                      this.props.touched.addressLine2
                        ? this.props.errors.addressLine2
                        : ""
                    }
                    handleBlur={(e) => {
                      handleFieldBlur(e);
                    }}
                  />
                </div>
              </div>
              <div className="o-layout u-m-none">
                <div className="o-layout__item u-1/3 u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none">
                  <Field
                    name="city"
                    data-testid="city"
                    type="text"
                    placeHolder={t(rk.COMMON.CITY)}
                    altPlaceholder={t(rk.COMMON.CITY).toUpperCase()}
                    id="city"
                    component={customInputComponent}
                    error={this.props.errors.city}
                    helpContent={
                      this.props.errors.city && this.props.touched.city
                        ? this.props.errors.city
                        : ""
                    }
                    handleBlur={(e) => {
                      handleFieldBlur(e);
                    }}
                  />
                </div>
                <div className="o-layout__item u-1/3 u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none">
                  <Field
                    name="state"
                    data-testid="state"
                    placeHolder={t(rk.COMMON.SELECT_STATE)}
                    id="state"
                    component={customInputSelectComponent}
                    options={regionOptions}
                    setFieldValue={setFieldValue}
                    error={this.props.errors.state}
                    helpContent={
                      this.props.errors.state && this.props.touched.state
                        ? this.props.errors.state
                        : ""
                    }
                  />
                </div>
                <div className="o-layout__item u-1/3 u-1/1@xs u-1/1@s u-p-none@xs u-p-none@s u-m-none">
                  <Field
                    name="postalCode"
                    data-testid="postalCode"
                    type="text"
                    placeHolder={t(rk.COMMON.ZIP_CODE)}
                    altPlaceholder={t(rk.COMMON.ZIP_CODE).toUpperCase()}
                    id="postalCode"
                    component={customInputComponent}
                    error={this.props.errors.postalCode}
                    onChange={(e) => {
                      e.target.value = e.target.value.toUpperCase();
                      this.formatZip(e, setFieldValue);
                    }}
                    helpContent={
                      this.props.errors.postalCode &&
                      this.props.touched.postalCode
                        ? this.props.errors.postalCode
                        : ""
                    }
                    setFieldValue={setFieldValue}
                    handleBlur={(e) => {
                      handleFieldBlur(e);
                    }}
                  />
                </div>
              </div>
            </>
          )}
          {(shouldShowVinField || isProtectionServices) && (
            <div id="vin-label-container">
              {(!(isDNS || isCorrectMyInfo || isDeleteMyInfoVALikeOrUTLike) ||
                isProtectionServices) && (
                <div>
                  {!isProtectionServices && (
                    <div className="o-layout u-pl">
                      <div
                        id="vin-label"
                        className="o-layout__item u-1/1 u-p-none@s u-p-none@xs"
                      >
                        {t(rk.COMMON.VIN_REQUIRED)}
                      </div>
                    </div>
                  )}
                  {isProtectionServices &&
                    (isCorrectMyInfo || isDeleteMyInfoSpecialPolicyState) && (
                      <div className="o-layout u-pl">
                        <div
                          id="vin-label"
                          className="o-layout__item u-1/1 u-p-none@s u-p-none@xs"
                        >
                          {t(rk.COMMON.VIN_REQUIRED_PS)}
                        </div>
                      </div>
                    )}
                  <div className="o-layout u-pl">
                    <div className="o-layout__item u-1/1 u-p-none@xs u-p-none@s">
                      <Field
                        name="vin"
                        data-testid="vin"
                        placeHolder={t(rk.COMMON.VIN)}
                        altPlaceholder={t(rk.COMMON.VIN).toUpperCase()}
                        type="text"
                        id="vin"
                        component={customInputComponent}
                        error={this.props.errors.vin}
                        helpContent={
                          this.props.errors.vin && this.props.touched.vin
                            ? this.props.errors.vin
                            : ""
                        }
                        value={values.vin?.toUpperCase()}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {this.props.showElectronicReport ? (
            <div className="u-p u-pt-none u-pb-large u-p-none@xs u-p-none@s">
              <div id="report-check-container" className="checkbox-container">
                <label htmlFor="reportCheck" className="checkbox-label">
                  <Field
                    name="reportCheck"
                    data-testid="reportCheck"
                    onClick={(e) => this.onReportCheck(e, setFieldValue)}
                    isChecked={this.props.values.reportCheck}
                    id="reportCheck"
                    component={checkboxComponent}
                    aria-labelledby="report-check-label"
                  />
                  <span id="report-check-label" className="checkbox-text">
                    {t(rk.MAILING_ADDRESS.REPORT_LABEL)}
                  </span>
                </label>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </React.Fragment>
    );
  }
}

MailingAddress.propTypes = {
  stateSelector: PropTypes.shape({
    currentStateResidence: PropTypes.string.isRequired,
    customerRelation: PropTypes.string,
    brandAffiliation: PropTypes.string,
    submissionOnBehalfOf: PropTypes.string,
  }).isRequired,
  selectedRequest: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  customerRelation: PropTypes.string,
  currentStateResidence: PropTypes.string,
  secureKey: PropTypes.shape({
    givenName: PropTypes.string,
    middleName: PropTypes.string,
    familyName: PropTypes.string,
    birthDate: PropTypes.string,
  }),
  initialValues: PropTypes.shape({
    ssn: (props, propName, componentName) => {
      if (!props[propName]) {
        return new Error(`${propName} is required in ${componentName}`);
      }
      if (typeof props[propName] !== "string") {
        return new Error(`${propName} must be a string in ${componentName}`);
      }
      if (props[propName].length === 0) {
        return new Error(
          `${propName} must not be an empty string in ${componentName}`
        );
      }
      return null;
    },
  }).isRequired,
  values: PropTypes.shape({
    reportType: PropTypes.string,
    reportTypeLabel: PropTypes.string,
    reportCheck: PropTypes.bool,
    vin: PropTypes.string,
  }),
  errors: PropTypes.object,
  touched: PropTypes.object,
  setFieldValue: PropTypes.func.isRequired,
  handleFieldBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  networkError: PropTypes.object,
  showReportOptions: PropTypes.bool,
  showElectronicReport: PropTypes.bool,
  isAccessMyInfo: PropTypes.bool,
  isKnowMyInfo: PropTypes.bool,
  isDNS: PropTypes.bool,
  isCorrectMyInfo: PropTypes.bool,
  isDeleteMyInfoVALikeOrUTLike: PropTypes.bool,
  isDeleteMyInfoSpecialPolicyState: PropTypes.bool,
  isDeleteMyInfoQC: PropTypes.bool,
  isProtectionServices: PropTypes.bool,
  t: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  stateSelector: state.stateSelector,
  country: state.initialReducer.country,
  language: state.initialReducer.language,
  customerRelation: state.stateSelector.customerRelation,
  currentStateResidence: state.stateSelector.currentStateResidence,
  selectedRequest: state.requestSelector.selectedRequest,
  secureKey: state.secureKey,
});

export default connect(mapStateToProps)(withTranslation()(MailingAddress));
